export default {"src":"/_next/static/media/OKTA.ede3722c.svg","height":18,"width":18};